import React, { PropsWithChildren } from "react";
import { useScrollLock } from "usehooks-ts";
import { Portal } from "component-library";
import { CrossThickIcon } from "assets";
import { useTranslation } from "i18n";
import ProfileButton from "pages/Profile/components/common/ProfileButton";

interface Props {
  onToggle?: () => void;
}

const FullScreenMediaViewer = ({
  onToggle,
  children,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  useScrollLock({});

  return (
    <Portal>
      <div className="fixed left-0 top-0 z-50 h-full w-full overflow-auto bg-black/90">
        <ProfileButton
          className="absolute right-4 top-4 z-10 rounded-full text-white"
          onClick={onToggle}
          aria-label={t("common:aria.label.closeMediaViewer")}
        >
          <CrossThickIcon aria-hidden="true" focusable="false" />
        </ProfileButton>
        {children}
      </div>
    </Portal>
  );
};

export default FullScreenMediaViewer;
